import axios from 'axios';

export default {
    getStates(){
        return axios.get("/api/states/?limit=1000")
    },
    getCities(state){
        return axios.get(`/api/cities/?limit=1000&estado=${state}`)
    },
}